
































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { BaseCampaignCancellationRequest } from '@/modules/base-campaign/models/base-campaign-request.model'

@Component({
  inheritAttrs: false,
  components: { BaseButton, Modal, Toggle, BaseInput, CurrencyInput }
})
export default class AdminCampaignCancellationDialog extends Vue {
  @Prop({ default: false }) value!: boolean
  @Prop({ default: null, required: true }) useCase!: BaseRequestLoadingHandler
  @Prop({ default: '' }) label: string
  @Prop({ default: false }) hasBtn: boolean
  @Prop({ default: 'lg' }) size: string
  @Prop({ required: true }) id!: number
  @Prop({ default: 0 }) returnAmount!: number
  @Prop({ default: 0 }) profitAmount!: number
  private requestData: BaseCampaignCancellationRequest = this.initialData()
  private dialogModel = this.value

  onSubmit(evt) {
    if (this.useCase !== null)
      this.useCase.execute(this.id, this.requestData).then(() => {
        if (this.useCase.isSuccess) this.dialogModel = false
      })
    else this.dialogModel = false
  }

  @Watch('dialogModel')
  onChange(newVal) {
    if (newVal) {
      this.requestData = this.initialData()
    }
  }

  initialData() {
    return {
      allow_return_to_wallet: true,
      return_to_wallet: this.returnAmount,
      allow_decrease_profit: true,
      decrease_profit: this.profitAmount,
      admin_note: ''
    }
  }

  get showTooltip() {
    return !Boolean(this.label)
  }

}
